// extracted by mini-css-extract-plugin
export default {"PrincipalContainer":"ServicesW_PrincipalContainer__49AtU","ArticleContainer":"ServicesW_ArticleContainer__P2pK8","Services":"ServicesW_Services__81fxy"};